import { cn } from "@/lib/utils";

const styles: Record<string, string> = {
  pending: "bg-status-pending/15 text-text-muted",
  tagged: "bg-status-tagged/15 text-status-tagged",
  in_progress: "bg-status-warn/15 text-status-warn",
  submitted: "bg-status-tagged/15 text-status-tagged",
  running: "bg-status-running/15 text-status-running",
};

export function StatusPill({ status }: { status: string }) {
  const label = status.replace("_", " ");
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize",
        styles[status] ?? "bg-bg-elevated text-text-muted",
      )}
    >
      {label}
    </span>
  );
}
